import { Card, Table, Space, Typography, Progress } from 'antd';
import React from 'react';
import ColorKey from "../../../components/ColorKey";
import { mapExposureColor, ExposureColors } from "./utils";
import { useEnsureTickersLoaded } from "../../../hooks/useEnsureTickersLoaded";
import TickerChip from "../../../components/TickerChip";
import ProportionLine from "../../../charts/ProportionLine";


const ExposureTable = ({ maxExposureData, currentWeights }) => {
  // Define the logic to get the color based on the quintile of max exposure
  const { tickers } = useEnsureTickersLoaded(maxExposureData.map(item => item.x.toLowerCase()));
  maxExposureData.sort((a, b) => b.value - a.value);

  const columns = [
    {
      title: 'Ticker',
      render: (text, record)=>{
        const ticker = tickers.find(x=>x.symbol===record.x.toLowerCase());
        return ticker ? <TickerChip ticker={ticker} /> : record.x;
      },
      width: 150,
    },
    {
      title: 'Current Weight',
      dataIndex: 'currentExposure',
      key: 'currentExposure',
      render: (text, record) => {

        return <ProportionLine keptPercentage={record.currentExposure}
                               removedPercentage={parseFloat(record.value)}
                               keptColor={'#7d02d3'}
                               removedColor={'#ff656e'}
                               borderRadius={0}
                               patternFillRemoved={true}
        />
      },
    },
    // Add other columns as needed
  ];

  const dataWithCurrentExposure = maxExposureData.map(item => ({
    ...item,
    currentExposure: currentWeights[item.x.toLowerCase()] * 100, // assuming currentWeights are fractions
    value: parseFloat(item.value),
  })).sort((a, b) => b.currentExposure - a.currentExposure);
  console.log('dataWithCurrentExposure', dataWithCurrentExposure)

  return (
        <Table
          dataSource={dataWithCurrentExposure}
          columns={columns}
          rowKey="x"
          scroll={{y: 600, x: 'max-content'}}
        />
  );
};

export default ExposureTable;
